// extracted by mini-css-extract-plugin
export default {"wrapper":"Scrollbars-wrapper___ju8JR"};